import { put, post, del, get } from './requests'

const resourcePath = 'document_templates'

export function updateDocumentTemplate ({ id, ...documentTemplate }) {
  return put(`${resourcePath}/${id}`, { documentTemplate })
}

export function createDocumentTemplate (documentTemplate) {
  return post(`${resourcePath}`, { documentTemplate })
}

export function deleteDocumentTemplate (templateId) {
  return del(`${resourcePath}/${templateId}`)
}

export function getContactPlaceholders (documentTemplateId) {
  return get(`${resourcePath}/${documentTemplateId}/contact_placeholders`)
}

export function createTemplateFromDocument (documentTemplate) {
  return post(`${resourcePath}/template_from_document`, { documentTemplate })
}

export function updateTemplateContent (id) {
  return post(`${resourcePath}/${id}/update_content`)
}

export function copyDocumentTemplate (id) {
  return post(`${resourcePath}/${id}/copy`)
}
